import { useQuery } from "@tanstack/react-query";

import { DUMMY_TOKEN } from "checkout-query-client/api/get-jwt-payload";
import { initKount } from "checkout-query-client/api/init-kount";

export const useFraudServices = (
  safetechMerchantId: string,
  checkoutSessionToken: string | undefined,
  kountSessionHostname: string
) => {
  return useQuery({
    queryKey: [
      {
        scope: "init-kount",
        checkoutSessionToken: checkoutSessionToken!,
        safetechMerchantId,
        kountSessionHostname,
      },
    ],
    queryFn: initKount,
    enabled:
      !!checkoutSessionToken &&
      !!safetechMerchantId &&
      !!kountSessionHostname &&
      checkoutSessionToken !== DUMMY_TOKEN,
  });
};
